import loadable, { ExtraComponentProps, LoadableComponent } from '@loadable/component';

import { Loader } from '@components';

export const Home: LoadableComponent<ExtraComponentProps> = loadable<any>(() => import('@containers/home'), {
	fallback: <Loader />
});

export const About: LoadableComponent<ExtraComponentProps> = loadable<any>(() => import('@containers/about'), {
	fallback: <Loader />
});

export const Soboo: LoadableComponent<ExtraComponentProps> = loadable<any>(() => import('@containers/soboo'), {
	fallback: <Loader />
});

export const Sources: LoadableComponent<ExtraComponentProps> = loadable<any>(() => import('@containers/sources'), {
	fallback: <Loader />
});

export const Forwarders: LoadableComponent<ExtraComponentProps> = loadable<any>(
	() => import('@containers/forwarders'),
	{
		fallback: <Loader />
	}
);
